export const premiumProviders = [
  {
    id: 101,
    name: 'Carlos Rodríguez',
    category: 'Electricidad',
    badge: 'Premium',
    description: 'Electricista certificado con más de 15 años de experiencia en instalaciones residenciales y comerciales. Especializado en sistemas de iluminación LED, tableros eléctricos y automatización del hogar. Trabajo garantizado y certificado.',
    serviceArea: 'Centro, Zona Plateada, Jardines de La Cruz',
    basePrice: 450,
    priceRange: '$450 – $2,500 MXN',
    rating: 4.9,
    reviewCount: 127,
    available: true,
    completedJobs: 342,
    responseTime: '30 min',
    skills: ['Instalaciones eléctricas', 'Reparaciones', 'Iluminación LED', 'Automatización'],
    images: [
      'https://public.readdy.ai/ai/img_res/97cf9bbfb9e9bd5f4cbad51516de21b0.jpg',
      'https://readdy.ai/api/search-image?query=LED%20lighting%20installation%20in%20elegant%20modern%20living%20room%20warm%20ambiance%20professional%20work%20clean%20finish%20high%20quality%20interior%20photography&width=800&height=500&seq=prem1b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Home%20automation%20smart%20electrical%20system%20setup%20modern%20house%20professional%20electrician%20tools%20organized%20workspace%20high%20quality%20photography&width=800&height=500&seq=prem1c&orientation=landscape'
    ],
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20electrician%20in%20clean%20orange%20safety%20vest%20smiling%20confident%20portrait%20studio%20neutral%20background%20high%20quality&width=200&height=200&seq=pavatar1&orientation=squarish'
  },
  {
    id: 102,
    name: 'Ana López',
    category: 'Plomería',
    badge: 'Destacado',
    description: 'Plomera certificada con experiencia en reparaciones de emergencia y nuevas instalaciones. Disponible para servicios urgentes. Atención rápida y profesional en toda el área de Aguascalientes con garantía en todos los trabajos.',
    serviceArea: 'Villa Asunción, Ojocaliente, Fraccionamiento Boulevares',
    basePrice: 500,
    priceRange: '$500 – $3,000 MXN',
    rating: 4.9,
    reviewCount: 156,
    available: true,
    completedJobs: 423,
    responseTime: '20 min',
    skills: ['Reparaciones urgentes', 'Instalaciones', 'Detección de fugas', 'Calentadores'],
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20plumber%20installing%20modern%20bathroom%20fixtures%20clean%20white%20tiles%20bright%20bathroom%20high%20quality%20photography%20professional%20finish&width=800&height=500&seq=prem2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20kitchen%20plumbing%20installation%20stainless%20steel%20sink%20professional%20work%20clean%20bright%20kitchen%20high%20quality%20photography&width=800&height=500&seq=prem2b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Water%20heater%20installation%20professional%20plumber%20residential%20home%20clean%20organized%20workspace%20high%20quality%20photography&width=800&height=500&seq=prem2c&orientation=landscape'
    ],
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20plumber%20confident%20smile%20work%20uniform%20clean%20studio%20portrait%20neutral%20background%20high%20quality%20photography&width=200&height=200&seq=pavatar2&orientation=squarish'
  },
  {
    id: 103,
    name: 'Laura Fernández',
    category: 'Carpintería',
    badge: 'Premium',
    description: 'Carpintera especializada en muebles a medida y restauración de piezas antiguas. Trabajo artesanal de alta calidad con maderas nobles. Diseños personalizados que se adaptan a cada espacio y estilo de vida.',
    serviceArea: 'Residencial Pulgas Pandas, Villas del Pilar, Ciudad Jardín',
    basePrice: 650,
    priceRange: '$650 – $8,000 MXN',
    rating: 4.8,
    reviewCount: 72,
    available: true,
    completedJobs: 198,
    responseTime: '2 horas',
    skills: ['Muebles a medida', 'Restauración', 'Instalaciones', 'Diseño personalizado'],
    images: [
      'https://readdy.ai/api/search-image?query=Custom%20handcrafted%20wooden%20furniture%20beautiful%20modern%20living%20room%20warm%20wood%20tones%20elegant%20interior%20design%20high%20quality%20photography%20professional%20finish&width=800&height=500&seq=prem3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Custom%20built-in%20wooden%20bookshelf%20modern%20home%20office%20warm%20oak%20finish%20professional%20carpentry%20high%20quality%20interior%20photography&width=800&height=500&seq=prem3b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Artisan%20woodworking%20workshop%20custom%20kitchen%20cabinets%20natural%20wood%20professional%20craftsmanship%20high%20quality%20photography&width=800&height=500&seq=prem3c&orientation=landscape'
    ],
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20carpenter%20workshop%20apron%20confident%20smile%20portrait%20studio%20neutral%20background%20high%20quality%20photography&width=200&height=200&seq=pavatar3&orientation=squarish'
  }
];

export const standardProviders = [
  {
    id: 201,
    name: 'María González',
    category: 'Limpieza',
    description: 'Servicio profesional de limpieza con productos ecológicos y atención al detalle.',
    serviceArea: 'Centro Histórico, Zona Centro',
    basePrice: 350,
    rating: 4.8,
    reviewCount: 203,
    available: true,
    completedJobs: 518,
    image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20service%20worker%20in%20uniform%20smiling%20bright%20modern%20clean%20home%20environment%20professional%20portrait&width=400&height=300&seq=std1&orientation=landscape'
  },
  {
    id: 202,
    name: 'Juan Martínez',
    category: 'Jardinería',
    description: 'Diseño y mantenimiento de jardines con plantas nativas y sistemas de riego eficientes.',
    serviceArea: 'Jardines de La Cruz, Fraccionamiento Valle',
    basePrice: 400,
    rating: 4.7,
    reviewCount: 89,
    available: false,
    completedJobs: 256,
    image: 'https://readdy.ai/api/search-image?query=Professional%20gardener%20with%20tools%20in%20a%20beautiful%20lush%20green%20garden%20natural%20lighting%20professional%20portrait%20photography&width=400&height=300&seq=std2&orientation=landscape'
  },
  {
    id: 203,
    name: 'Pedro Sánchez',
    category: 'Pintura',
    description: 'Pintor profesional con técnicas decorativas y acabados impecables en interior y exterior.',
    serviceArea: 'Insurgentes, Zona Industrial',
    basePrice: 380,
    rating: 4.6,
    reviewCount: 94,
    available: true,
    completedJobs: 287,
    image: 'https://readdy.ai/api/search-image?query=Professional%20painter%20with%20paint%20roller%20brush%20colorful%20modern%20room%20clean%20work%20environment%20professional%20portrait&width=400&height=300&seq=std3&orientation=landscape'
  },
  {
    id: 204,
    name: 'Roberto Díaz',
    category: 'Aire Acondicionado',
    description: 'Técnico certificado en climatización. Instalación, mantenimiento y reparación de todas las marcas.',
    serviceArea: 'Fracc. Héroes, Villa Asunción',
    basePrice: 480,
    rating: 4.7,
    reviewCount: 118,
    available: false,
    completedJobs: 334,
    image: 'https://readdy.ai/api/search-image?query=HVAC%20technician%20with%20air%20conditioning%20unit%20tools%20uniform%20professional%20indoor%20workspace%20high%20quality%20portrait%20photography&width=400&height=300&seq=std4&orientation=landscape'
  },
  {
    id: 205,
    name: 'Sofía Ramírez',
    category: 'Cerrajería',
    description: 'Cerrajera profesional para emergencias. Apertura de puertas y sistemas de seguridad.',
    serviceArea: 'Toda el área metropolitana',
    basePrice: 420,
    rating: 4.9,
    reviewCount: 145,
    available: true,
    completedJobs: 412,
    image: 'https://readdy.ai/api/search-image?query=Professional%20female%20locksmith%20with%20security%20tools%20keys%20confident%20pose%20clean%20workspace%20professional%20portrait%20photography&width=400&height=300&seq=std5&orientation=landscape'
  },
  {
    id: 206,
    name: 'Miguel Torres',
    category: 'Herrería',
    description: 'Herrería artesanal y estructural. Rejas, puertas, escaleras y trabajos a medida.',
    serviceArea: 'San Marcos, Pabellón de Arteaga',
    basePrice: 600,
    rating: 4.5,
    reviewCount: 61,
    available: true,
    completedJobs: 143,
    image: 'https://readdy.ai/api/search-image?query=Professional%20metal%20worker%20blacksmith%20with%20welding%20equipment%20and%20iron%20gates%20workshop%20artistic%20professional%20portrait%20photography&width=400&height=300&seq=std6&orientation=landscape'
  }
];
